import {
  Component,
  HostBinding,
  TemplateRef,
  Input,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { UserService } from '@app/providers/user/user.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
  FormGroup,
  FormBuilder,
  Validators,
  UntypedFormGroup,
} from '@angular/forms';

import { map, takeWhile, finalize, tap, switchMap, combineLatest } from 'rxjs';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { UserAuthentified } from '@app/authentification/user-authentified.interface';

@Component({
    selector: 'ea-contact-card',
    templateUrl: './ea-contact-card.component.html',
    styleUrls: ['./ea-contact-card.component.scss'],
    standalone: false
})
export class EaContactCardComponent implements OnInit, OnDestroy {
  @Input() currentScreen: string;
  @Input() productInfo: string;
  @Input() productLabel: string;
  @Input() productLabelInfo: string;
  @Input() customLabel: boolean;
  @Input() name: string;
  @Input() automaticConsultant: boolean = false;
  @Input() appearance: 'bar' | 'card' = 'bar';

  @HostBinding('class.card-appearance')
  get isCardAppearance(): boolean {
    return this.appearance === 'card';
  }

  private userData: UserAuthentified;
  modalRef: BsModalRef;
  hasPhone: boolean;
  submitting = false;
  numberForm: UntypedFormGroup;
  consultant$: any;
  private alive = true;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private modalService: BsModalService,
    private attributionDao: AttributionDao,
  ) {}

  ngOnInit() {
    this.consultant$ = this.userService.getUser().pipe(
      takeWhile(() => this.alive),
      tap(user => {
        if (user) {
          this.userData = user;
          if (this.userData.contacts) {
            this.hasPhone = !!this.userData.contacts.find(
              elm =>
                (elm.type === 'TEL_FIX' || elm.type === 'TEL_MOB') && elm.value,
            );
          }
        }
      }),
      switchMap(data => {
        return this.attributionDao.getConsultant().pipe(
          tap(data => {
            if (this.automaticConsultant) {
              data?.firstName
                ? (this.productLabel += data.firstName)
                : (this.productLabel += 'votre consultant');
            }

            return data;
          }),
        );
      }),
    );

    this.numberForm = this.fb.group({
      phone: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(12),
          Validators.pattern('[0-9]+'),
        ]),
      ],
    });
  }

  showModal(event: any, template: TemplateRef<any>): void {
    if (this.hasPhone) {
      this.sentRequestContact();
    }
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'ea-modal-contact' }),
    );
  }

  hideModal() {
    if (this.modalRef) {
      this.modalRef.hide();
      this.modalRef = null;
    }
    this.submitting = false;
  }

  sentRequestContact() {
    // this.submitting = true;
    this.userService
      .requestContact(this.userData.id, {
        currentScreen: this.currentScreen,
        productInfo: this.productInfo,
      })
      .pipe(
        takeWhile(() => this.alive),
        finalize(() => (this.submitting = false)),
      )
      .subscribe(
        () => {
          // this.hasPhone = true;
        },
        err => {
          if (err && err.status === 401) {
            this.hideModal();
          }
        },
      );
  }

  onNumberForm(form: any) {
    if (form.valid) {
      this.submitting = true;
      this.hasPhone = !this.hasPhone;
      let body = {
        id: null,
        isMain: true,
        label: null,
        type: 'TEL_MOB',
        value: form.value.phone,
      };
      this.userService
        .updateContact(this.userData.id, body)
        .pipe(
          takeWhile(() => this.alive),
          finalize(() => (this.submitting = false)),
        )
        .subscribe(
          () => {
            this.sentRequestContact();
            this.hasPhone = true;
          },
          err => {
            if (err && err.status === 401) {
              this.hideModal();
            }
          },
        );
    }
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
